if (!customElements.get('blog-gallery')) {
  customElements.define(
    'blog-gallery',
    class BlogGallery extends HTMLElement {
      constructor() {
        super();
        this.grid = this.querySelector('[data-blog-gallery-grid]');
        this.sentinel = this.querySelector('[data-blog-gallery-sentinel]');
        this.sectionId = this.dataset.sectionId;
        this.loading = false;
      }

      connectedCallback() {
        if (!this.grid || !this.sentinel || !this.nextUrl) return;

        // Signal to CSS that infinite scroll is active (hides no-JS fallback link).
        this.setAttribute('data-infinite', 'true');

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
          },
          { rootMargin: '600px 0px' }
        );
        this.observer.observe(this.sentinel);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      get nextUrl() {
        return this.grid.dataset.nextUrl || '';
      }

      set nextUrl(value) {
        this.grid.dataset.nextUrl = value || '';
      }

      async loadNext() {
        if (this.loading || !this.nextUrl) return;
        this.loading = true;
        this.setAttribute('data-loading', 'true');

        const separator = this.nextUrl.includes('?') ? '&' : '?';
        const url = `${this.nextUrl}${separator}section_id=${this.sectionId}`;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Request failed: ${response.status}`);

          const text = await response.text();
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const newGrid = parsed.querySelector('[data-blog-gallery-grid]');
          if (!newGrid) {
            this.stop();
            return;
          }

          const fragment = document.createDocumentFragment();
          newGrid.querySelectorAll('[data-blog-gallery-tile]').forEach((tile) => {
            fragment.appendChild(tile);
          });
          this.grid.appendChild(fragment);

          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(this.grid);
          }

          // Advance to the page after the one we just appended.
          this.nextUrl = newGrid.dataset.nextUrl || '';
          if (!this.nextUrl) this.stop();
        } catch (error) {
          console.error('[blog-gallery]', error);
          this.stop();
        } finally {
          this.loading = false;
          this.removeAttribute('data-loading');
        }
      }

      stop() {
        this.nextUrl = '';
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
